export default "__VITE_ASSET__4b0c6a4d__"